import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';

import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';

import React from 'react';
import { Row, Col, Input, Divider, Button, message, Select } from 'antd';
import { EditOutlined } from '@ant-design/icons';

const measureConfs = {
    TRADE: '交易核心指标',
    USER: '用户核心指标',
    REFERRAL: '导流核心指标'
}

class GroupMeasureDetailView extends React.Component {
    constructor() {
        super();
        this.state = {
            editing: false,
        };
    }

    render() {
        return <>
            <Row>
                <Col>
                    <h2>指标详情</h2>
                </Col>
            </Row>
            <Divider />
            <Row style={{ padding: '0 30px 0 30px' }}>
                <Col>
                    <h4>基础信息</h4>
                </Col>
                {(this.state.editable && !this.state.editing) && <>
                    <Col flex="auto"></Col>
                    <Col>
                        <Button
                            icon={<EditOutlined />}
                            onClick={() => {
                                this.setState({ editing: true });
                                this.editor.updateOptions({ readOnly: false });
                            }}
                            type='link'
                        ></Button>
                    </Col>
                </>}
            </Row>
            <Row style={{ textAlign: 'left', margin: '0 0 8px 0', padding: '0 0 0 30px' }}>
                <Col flex="80px">
                    <span>名称：</span>
                </Col>
                <Col flex="200px" style={{ margin: '0 8px 0 0' }}>
                    {this.state.editing
                        ? <Input
                            value={this.state.name}
                            onChange={({ target: { value } }) => this.setState({ name: value })}
                            size="small"
                        />
                        : <span style={{ color: 'gray' }}>{this.state.name}</span>}
                </Col>

                <Col flex="80px">
                    <span>类型：</span>
                </Col>
                <Col flex="200px" style={{ margin: '0 8px 0 0' }}>
                    {this.state.editing
                        ? <Select
                            value={this.state.category}
                            onChange={category => this.setState({ category })}
                            size='small'
                            style={{ width: '100%' }}
                        >
                            <Select.Option value="TRADE">交易核心指标</Select.Option>
                            <Select.Option value="USER">用户核心指标</Select.Option>
                            <Select.Option value="REFERRAL">导流核心指标</Select.Option>
                        </Select>
                        : <span style={{ color: 'gray' }}>{measureConfs[this.state.category]}</span>}
                </Col>

                <Col flex="80px">
                    <span>创建人：</span>
                </Col>
                <Col flex="200px" style={{ margin: '0 8px 0 0' }}>
                    <span style={{ color: 'gray' }}>{this.state.creatorName}</span>
                </Col>
            </Row>
            <Row style={{ textAlign: 'left', padding: '0 0 0 30px' }}>
                <Col flex="80px">
                    <span>创建时间：</span>
                </Col>
                <Col flex="200px" style={{ margin: '0 8px 0 0' }}>
                    <span style={{ color: 'gray' }}>{this.state.createdAt}</span>
                </Col>

                <Col flex="80px">
                    <span>更新时间：</span>
                </Col>
                <Col flex="200px" style={{ margin: '0 8px 0 0' }}>
                    <span style={{ color: 'gray' }}>{this.state.updatedAt}</span>
                </Col>
            </Row>
            <Divider />
            <Row style={{ padding: '0 0 0 30px' }}>
                <Col>
                    <h4>定义和口径</h4>
                </Col>
            </Row>
            <Row style={{ textAlign: 'left', margin: '0 0 8px 0', padding: '0 30px 0 30px' }}>
                <Col flex="80px">
                    <span>定义：</span>
                </Col>
                <Col flex="auto">
                    <Input.TextArea
                        value={this.state.desc}
                        onChange={({ target: { value } }) => this.setState({ desc: value })}
                        readOnly={!this.state.editing}
                        style={{ width: '100%' }}
                        rows={3}
                    />
                </Col>
            </Row>
            <Row style={{ textAlign: 'left', margin: '0 0 8px 0', padding: '0 30px 0 30px' }}>
                <Col flex="80px">
                    <span>文字口径：</span>
                </Col>
                <Col flex="auto">
                    <Input.TextArea
                        value={this.state.spec}
                        onChange={({ target: { value } }) => this.setState({ spec: value })}
                        readOnly={!this.state.editing}
                        style={{ width: '100%' }}
                        rows={3}
                    />
                </Col>
            </Row>
            <Row style={{ textAlign: 'left', margin: '0 0 8px 0', padding: '0 30px 0 30px' }}>
                <Col flex="80px">
                    <span>SQL口径：</span>
                </Col>
                <Col flex="auto">
                    <div id="side-spec-by-sql-editor" style={{ textAlign: 'left', border: '1px solid #d9d9d9' }}></div>
                </Col>
            </Row>
            {(this.state.editable && this.state.editing) && <Row justify='center'>
                <Col flex="200px">
                    <Button
                        type="primary"
                        onClick={this.save.bind(this)}
                    >保存</Button>

                </Col>
                <Col flex="200px">
                    <Button onClick={this.abort.bind(this)}>放弃</Button>
                </Col>
            </Row>}
        </>;
    }

    async componentDidMount() {
        await auth.authenticate();
        const measure = await UIFetchService.get(`/api/v1/measure/group/measures/${this.props.measureId}`);
        this.setState({ ...measure, editable: auth.allow('datap:admin') });
        auth.appendLog(`数据地图-集团核心指标-${measure.name}`);

        const domNode = document.getElementById('side-spec-by-sql-editor');
        const instance = monaco.editor.create(domNode, {
            value: measure.specBySql,
            theme: 'vs-light',
            fontSize: 12,
            language: 'sql',
            automaticLayout: true,
            readOnly: true
        });
        this.editor = instance;
        this.editor.layout({
            height: 300
        });
    }

    async save() {
        const measure = { ...this.state, specBySql: this.editor.getValue() };
        await UIFetchService.put(`/api/v1/measure/group/measures/${this.props.measureId}`, measure);
        message.success('保存成功');
        this.setState({ editing: false });
        this.editor.updateOptions({ readOnly: true });
    }

    async abort() {
        const measure = await UIFetchService.get(`/api/v1/measure/group/measures/${this.props.measureId}`);
        this.setState({ ...measure, editing: false });
        this.editor.updateOptions({ readOnly: true });
    }
}

export default GroupMeasureDetailView;